// Footer Sticky Animation - Footer fixed, FAQ scrolls over
(function() {
  'use strict';
  
  // Get the sections
  const faqSection = document.querySelector('.shopify-section--faq');
  const footerSection = document.querySelector('.shopify-section--footer');
  const revealImageSection = document.querySelector('.shopify-section--revealed-image');
  
  if (!faqSection || !footerSection) {
    console.log('FAQ or Footer section not found');
    return;
  }
  
  // Only apply on desktop
  if (window.innerWidth < 700) {
    return;
  }
  
  let ticking = false;
  let isFooterUnsticky = false;
  
  function updateFooterState() {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    // Get FAQ section position
    const faqTop = faqSection.offsetTop;
    const faqBottom = faqTop + faqSection.offsetHeight;
    
    // Get footer section position
    const footerTop = footerSection.offsetTop;
    
    // Check if we've scrolled past FAQ section completely
    // Footer should become unsticky when FAQ completely passes over it
    if (scrollTop + windowHeight >= documentHeight - 100) {
      // Near bottom of page - deactivate sticky footer
      if (!isFooterUnsticky) {
        footerSection.classList.add('footer-unsticky');
        isFooterUnsticky = true;
      }
    } else if (scrollTop >= faqTop - windowHeight) {
      // FAQ section is visible - keep footer sticky
      if (isFooterUnsticky) {
        footerSection.classList.remove('footer-unsticky');
        isFooterUnsticky = false;
      }
    } else {
      // Before FAQ section - footer not sticky yet
      if (!isFooterUnsticky) {
        footerSection.classList.add('footer-unsticky');
        isFooterUnsticky = true;
      }
    }
    
    ticking = false;
  }
  
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateFooterState);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', updateFooterState);
  
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth >= 700 && !ticking) {
        window.requestAnimationFrame(updateFooterState);
        ticking = true;
      }
    }, 150);
  });
  
  // Initial check
  updateFooterState();
  
  console.log('Footer sticky animation initialized');
  
})();